exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chartWrapper {\n  position: relative;\n  overflow-y: scroll;\n}\n.chartAreaWrapper {\n  height: 400px;\n}\n", ""]);

// exports
